import { render, staticRenderFns } from "./SessionsBlock.vue?vue&type=template&id=98817804&scoped=true"
import script from "./SessionsBlock.vue?vue&type=script&lang=js"
export * from "./SessionsBlock.vue?vue&type=script&lang=js"
import style0 from "./SessionsBlock.vue?vue&type=style&index=0&id=98817804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98817804",
  null
  
)

export default component.exports